import React, { useEffect } from "react";
import ShopBoxEmptyState from "./empty-state";
import ShopCard from "./shop-card";
import useArenaShop from "../../../../hooks/useArenaShop";
import CircularProgress from "../../../../components/CircularProgress";
import { Assets } from "../../../../constants/assets";
import { Link, useNavigate } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch } from "react-redux";
import { CloseArenaDialog } from "../../../../redux/arena-dialog/action";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
type Props = {};

const ShopBox = (props: Props) => {
  
  const { data, loading, getShopData } = useArenaShop();
  const { t } = useAppTranslation("battle");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    getShopData();
  }, []);

  return (
    <PerfectScrollbar
      style={{ minHeight: 111 }}
      className="bg-paper-2 p-2 rounded-3 d-flex flex-column overflow-auto "
    >
      {!loading && !!data?.rewards?.length && (
        <div className="d-flex  gap-2 align-items-center ">
          <div className="d-flex flex-column align-items-center me-3 ms-2">
            <div className="light-yellow ">{t("shop.title")}</div>
            <Link onClick={()=>dispatch(CloseArenaDialog())} to={"/marketplace?type=6"}>
              <img
                width={90}
                src={Assets.icons.arenaShop}
                alt="bloodgem-pack"
              />
            </Link>
          </div>
          {data.rewards.map((reward) => (
            <ShopCard
              key={reward.id}
              reward={reward}
              onOpen={() => {
                dispatch(CloseArenaDialog());
                navigate("/marketplace?type=6");
              }}
            />
          ))}
        </div>
      )}
      {loading && (
        <div className="flex-1 w-100 h-100 d-flex align-items-center justify-content-center">
          <CircularProgress />
        </div>
      )}
      {!loading && (!data || data.rewards?.length === 0) && (
        <ShopBoxEmptyState />
      )}
    </PerfectScrollbar>
  );
};

export default ShopBox;
